export const appContainer = document.getElementById('app')!;
